import Presentation from '@components/blog/presentation';

const PresentationComponent = () => {
  return <Presentation />;
};

export default PresentationComponent;
